import validate from "/builds/asar-studio/ticket-me-biz/ticketme/node_modules/.pnpm/nuxt@3.13.2_@parcel+watcher@2.5.0_@types+node@20.17.9_eslint@8.57.1_ioredis@5.4.1_magicast@0._ruucxm5k2o6hhsctrfbvgmy4x4/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/builds/asar-studio/ticket-me-biz/ticketme/node_modules/.pnpm/nuxt@3.13.2_@parcel+watcher@2.5.0_@types+node@20.17.9_eslint@8.57.1_ioredis@5.4.1_magicast@0._ruucxm5k2o6hhsctrfbvgmy4x4/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/builds/asar-studio/ticket-me-biz/ticketme/web/shop/src/middleware/auth.ts")
}